export const STRING_MENU = {
  MANAGEMENT_BRANCH: "Quản Lý Chi Nhánh",
  MANAGEMENT_EMPLOYEE: "Quản Lý Nhân Viên",
  WORKSTATION_AREA: "Khu Máy Trạm",
  MANAGEMENT_COMPUTERS: "Quản Lý Máy Trạm",
  MANAGEMENT_SERVICE: "Quản Lý Dịch Vụ",
  PROBLEM_WARNING: "Cảnh Báo Sự Cố",
  MANAGEMENT_ACCOUNT_CUSTOMER: "Quản Lý Tài Khoản",
  MANAGEMENT_PROMOTION: "Khuyến Mãi",
  MANAGEMENT_WAREHOUSING: "Quản Lý Kho",
  MANAGEMENT_BOOKING: "Quản Lý Booking",
  MANAGEMENT_RECHARGE_PACKAGE: "Quản Lý Gói Nạp",
  MANAGEMENT_PLAY_TIME_PACKAGE: "Quản Lý Gói Giờ Chơi",
  CHAT: "Chat",
  DASHBOARD: "Tổng Quan",
  REPORT: "Báo Cáo",
  MANAGEMENT_GAME: "Quản Lý Game",
  MANAGEMENT_NEWFEED: "Quản Lý Tin Tức",
  EMPLOYEE_NOTIFICATION_HISTORY: "Lịch Sử Thông Báo",
  MANAGEMENT_ORDER: "Quản Lý Order",
  LIST_ORDER: "Danh Sách Order",
  RECHARGE_HISTORY: "Lịch Sử Nạp",
  SETTING: "Cài Đặt",
  PRINTER: "Quản Lý Máy In",
  BACKGROUND_LOGIN: "Quản Lý Hình Nền",
  COMPUTERS: "Danh Sách Máy Trạm",
  PRODUCT: "Quản Lý Thực Đơn ",
  API_KEY: "Quản lý API Key",
  TIMELINE: "Lịch Sử Hoạt Động",
};

export const STRING_SUB_MENU = {
  LIST_BRANCH: "Danh Sách Chi Nhánh",
  LIST_PRODUCT: "Danh Sách Thực Đơn",
  LIST_EMPLOYEE: "Danh Sách Nhân Viên",
  LIST_DEPARTMENT: "Danh Sách Bộ Phận",
  PERMISSIONS: "Phân Quyền Nhân Viên",
  OPEN_CLOSE_SHIFT: "Đóng Ca, Mở Ca",
  LIST_OPEN_CLOSE_SHIFT: "Danh Sách Đóng Ca, Mở Ca",
  LIST_SHIFT: "Lịch Làm Việc",
  LIST_ATTENDANCE: "Lịch Sử Chấm Công",
  LIST_ORDER: "Danh Sách Order",
  LIST_WORKSTATION: "Danh Sách Khu Máy Trạm",
  LIST_ACCOUNT_CUSTOMER: "Danh Sách Tài Khoản Khách Hàng",
  ACCOUNT_CUSTOMER_DETAIL: "Chi Tiết Tài Khoản Khách Hàng",
  WALLET_TRANSACTIONS: "Nạp Tiền",
  CONFIG_PACKAGE_DEPOSIT: "Config Gói Nạp",
  LIST_PROMOTION_PROGRAMS: "Danh Sách Chương Trình",
  CATEGORY: "Danh sách nhóm",
  MATERIAL_AND_PRODUCT: "Nguyên Liệu",
  WAREHOUSING: "Kho",
  INVENTORY_WAREHOUSE: "Kiểm Kê",
  INCOME_AND_EXPENDITURE: "Thu Chi",
  CATEGORIES_RECEIPT: "Danh Mục Thu Chi",
  LIST_RECHARGE_PACKAGE: "Danh Sách Gói Nạp",
  LIST_GAME: "Danh Sách Game",
  LIST_CATEGORY_GAME: "Danh Mục Game",
  RECHARGE_HISTORY: "Nạp Tiền",
  SETTING: "Cài Đặt",
  CHAT: "Chat",
  LIST_PROMOTION_BUY_HISTORY: "Đơn Hàng Khuyến Mãi Chờ Xác Nhận",
  LIST_API_KEY: "Danh Sách API Key",
  // New Promotion
  PROMOTION_MASTERS: "Chiến Dịch Khuyến Mãi",
  VOUCHER_TEMPLATES: "Mẫu Voucher",
  VOUCHERS: "Danh Sách Voucher",
  PROMOTION_REPORTS: "Báo Cáo Khuyến Mãi",
  // Reports
  REPORTS_DASHBOARD: "Tổng Quan Báo Cáo",
  REPORT_REVENUE: "Báo Cáo Doanh Thu",
  REPORT_COMPUTER_PERFORMANCE: "Hiệu Suất Máy",
  REPORT_WORKSTATION_STATUS: "Trạng Thái Máy Trạm",
  REPORT_PRODUCT_SALES: "Báo Cáo Sản Phẩm",
  REPORT_SHIFT_CLOSE: "Báo Cáo Chốt Ca",
  LIST_PROMOTION_CREDIT: "Tặng Tiền Khuyến Mãi",
  LIST_PLAY_TIME_PACKAGE: "Danh Sách Gói Giờ Chơi",
  PLAY_TIME_TRANSACTIONS: "Giao Dịch Gói Giờ Chơi",
};
